/**
 * 打开 53kf 客服弹窗
 * 由于每个学校的 53kf JS 由接口下发并动态注入，这里先判断 $53 是否已加载完成
 * @param {string} affim - 如果没有 53客服，则打开这个 affim 链接
 */
export default function(affim) {

    if (typeof window.$53 !== 'undefined' && window.$53.createApi) {
        var _53api = window.$53.createApi();
        _53api.push('cmd', 'kfclient');
        _53api.push('type', 'popup');
        _53api.query();
        return;
    }

    if (affim) {
        window.open(affim, '_blank');
    }
}
